import './Header.scss';

export default function Header() {
    return (
        <div id='header-div'>
            Reignforest
        </div>
    );
}